import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import jobExperienceApi from '@/api/job_experience_api';
import {SET_EXPERIENCE, SET_EXPERIENCES} from '@/store/mutationTypes';

export const experienceModule = namespace('jobExperience');
export interface Experience {
  [key: string]: any;
}

interface ExperienceState {
  experiences: Experience[];
  experience: Experience | null;
}
export default <Module<ExperienceState, RootState>>{
  namespaced: true,
  state: {
    experiences: [],
    experience: null,
  },
  mutations: {
    [SET_EXPERIENCES](state, data) {
      state.experiences = data;
    },
    [SET_EXPERIENCE](state, data) {
      state.experience = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await jobExperienceApi.all(params);
        commit(SET_EXPERIENCES, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getdetail({commit}, id) {
      try {
        const data = await jobExperienceApi.detail(id);
        commit(SET_EXPERIENCE, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async update(_, {id, payload}) {
      try {
        const data = await jobExperienceApi.update(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async create(_, payload) {
      try {
        const data = await jobExperienceApi.create(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await jobExperienceApi.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
